import 'assets/plugins/i18n'
import 'assets/plugins/mui-tabs'
import 'assets/plugins/react-toastify'
import 'assets/plugins/simplebar-react'
import 'assets/plugins/swiper'
import 'assets/plugins/tinymce'
import i18n from 'i18next'
import { any } from 'prop-types'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from 'store'
import { ThemeProvider } from 'styled-components'
import './index.css'
import './style.css'
const Providers = ({ children = 'No content' }) => (
	<Provider store={store}>
		<ThemeProvider theme={{}}>
			<I18nextProvider i18n={i18n}>
				<BrowserRouter>{children}</BrowserRouter>
			</I18nextProvider>
		</ThemeProvider>
	</Provider>
)
Providers.propTypes = {
	children: any,
}
export default Providers
